// DELIVERY

export const GET_DELIVERY_DETAILS = "GET_DELIVERY_DETAILS";
export const GET_DELIVERY_DETAILS_BEGIN = "GET_DELIVERY_DETAILS_BEGIN";
export const GET_DELIVERY_DETAILS_SUCCESS = "GET_DELIVERY_DETAILS_SUCCESS";
export const GET_DELIVERY_DETAILS_FAIL = "GET_DELIVERY_DETAILS_FAIL";
